module.exports = [{
      plugin: require('/var/lib/jenkins/workspace/lyn_clone/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-135977149-1","head":false},
    },{
      plugin: require('/var/lib/jenkins/workspace/lyn_clone/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/lib/jenkins/workspace/lyn_clone/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
